var React = require('react');
var ReactDOM = require('react-dom');
var Reflux = require('reflux');
var ScreenWid = require('./stores/screen-wid-store');

module.exports = React.createClass({

    mixins: [ Reflux.ListenerMixin ],

    getInitialState: function() {
      return { prefix: this.props.prefix ? this.props.prefix : "",
               title: this.props.title ? this.props.title : "",
               desc: this.props.desc ? this.props.desc : "" }
    },

    componentDidMount: function() {
      var bgImg = this.props.image;

      if ("SM" == ScreenWid.width && this.props.imageM) {
        bgImg = this.props.imageM;
      }
      jQuery(ReactDOM.findDOMNode(this.refs.headerImg))
          .css('background', 'url(' + bgImg + ') center bottom no-repeat');

      if (this.props.mainDescDiv) {
        jQuery(ReactDOM.findDOMNode(this.refs.mainDesc)).append(this.props.mainDescDiv);
      }
    },

    setContent: function(mainPrefix, mainImgSource, mainTitle, mainDesc, mainDescDiv) {
      this.setState({ prefix: mainPrefix,
                      title: mainTitle,
                      desc: mainDesc });
      jQuery(ReactDOM.findDOMNode(this.refs.headerImg))
          .css('background', 'url(' + mainImgSource + ') center bottom no-repeat');
      if (mainDescDiv) {
        jQuery(ReactDOM.findDOMNode(this.refs.mainDesc)).append(mainDescDiv);
      }
    },
    
    render: function() {

        return <header className="container">
            <div className="row">
                <div className="for-border">
                    <div ref="headerImg" className="header-img"></div>
                </div>
                <div className="text-wrap col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2">
                    <p className="lead">{this.state.prefix}</p>
                    <h1>{this.state.title}</h1>
                    <div ref="mainDesc"></div>
                    <p>{this.state.desc}</p>
                </div>
            </div>
        </header>
  }
});

